module.exports = __webpack_public_path__ + "media/components/Dashboard/components/thumbnail-60cc56d4e6f1a52fe4e3c90a0362b190.png";